import React from 'react';
import { message, Space, Typography } from "antd";
import Table from "../../../../componets/Table";
import { useAppDispatch, useAppSelector } from "../../../../store/hooks";
import { ColumnsType } from "antd/es/table";
import { Button, ButtonDestroy, ButtonEdit } from "../../../../componets/Buttons";
import {CheckCircleOutlined, EyeInvisibleOutlined, EyeOutlined, StopOutlined} from "@ant-design/icons";
import { setEditId, StickerPackInterface } from "../../../../store/sticker_maker/stickerPacksSlice";
import { EntityId } from "@reduxjs/toolkit";
import {
  blockStickerPack,
  destroyStickerPack, publishStickerPack,
  unBlockStickerPack, unPublishStickerPack
} from "../../../../actions/sticker_maker/stickerPacksActions";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Tags } from "./_Tags";
import { doHighlight } from "../../../../helpers/TextHelpers";
import Meta from "./_Meta";
const { Paragraph } = Typography;

interface ListTableInterface {
  className?: string;
}

const _ListTable = ({ className }: ListTableInterface) => {
  const navigate        = useNavigate();
  const dispatch        = useAppDispatch();
  const [searchParams]  = useSearchParams();
  const term            = searchParams.get('term') || '';
  const ids             = useAppSelector(state => state.stickerMaker.stickerPacks.ids);
  const stickerPacks    = useAppSelector(state => state.stickerMaker.stickerPacks.entities);
  const data            = ids ? ids.map(id => stickerPacks[id]) : [];

  function onClickEdit(id: EntityId) {
    dispatch(setEditId(id));
  }

  function onClickDestroy(id: EntityId) {
    handleDestroy(id).catch(console.error);
  }

  async function handleDestroy (id: any) {
    const resultAction = await dispatch(destroyStickerPack(id));

    if (destroyStickerPack.fulfilled.match(resultAction)) {
      message.success(`ItemID ${id} was successful deleted`);
      setTimeout(() => navigate(0), 1000);
    }

    if (destroyStickerPack.rejected.match(resultAction)) {
      message.error(resultAction.error.message);
    }
  }

  function onClickUnBlock(id: number) {
    dispatch(unBlockStickerPack(id));
  }

  function onClickBlock(id: number) {
    dispatch(blockStickerPack(id));
  }

  function unPublish(id: number) {
    dispatch(unPublishStickerPack(id));
  }

  function publish(id: number) {
    dispatch(publishStickerPack(id));
  }

  const ToggleBlockButton = ({ id, status } : { id: number; status: number }) => {
    if (status === 2) {
      return <Button key={`unblock-${id}`} title='UnBlock' onClick={() => onClickUnBlock(id)} icon={CheckCircleOutlined} />;
    } else {
      return <Button key={`block-${id}`} title='Block' onClick={() => onClickBlock(id)} icon={StopOutlined} />;
    }
  }

  const TogglePublishButton = ({ id, published } : { id: number; published: boolean }) => {
    if (published) {
      return <Button key={`unpublish-${id}`} title='UnPublish' onClick={() => unPublish(id)} icon={EyeInvisibleOutlined} />
    } else {
      return <Button key={`publish-${id}`} title='Publish' onClick={() => publish(id)} icon={EyeOutlined} />
    }
  }

  const columns: ColumnsType<StickerPackInterface> = [
    {
      key: 'sticker_pack',
      title: 'StickerPack',
      render: (_, stickerPack) => {
        return <Meta stickerPack={stickerPack} size='medium' showStats={true} />;
      },
      width: 185,
      ellipsis: true
    },

    {
      key: 'search_text',
      title: 'Search text & Tags',
      render: (_, { search_text, category_ids }) => {
        return (
          <div>
            <Paragraph ellipsis={{ rows: 2, expandable: true }}>
              {doHighlight(search_text, term)}
            </Paragraph>

            <Tags category_ids={category_ids} />
          </div>
        );
      },
      width: 250
    },

    {
      key: 'action',
      title: 'Action',
      render: (_, { id, status, published}) => {
        return (
          <Space size="middle">
            <TogglePublishButton id={id} published={published} />
            <ToggleBlockButton id={id} status={status} />
            <ButtonEdit key={'button-edit'} onClick={() => onClickEdit(id)} />
            <ButtonDestroy key='button-destroy' onClick={() => onClickDestroy(id)} />
          </Space>
        );
      },
      width: 150
    },
  ];

  return (
    <div className={className}>
      <Table
        rowKey='id'
        columns={columns}
        dataSource={data}
      />
    </div>
  )
}

export default _ListTable;
